/*
 * @Author: mannuo.wu mannuo.wu@cyberway.net.cn
 * @Date: 2024-09-09 23:03:32
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2026-06-25 11:19:55
 * @FilePath: \sip-tpm-activity-ui\src\index.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
//@ts-nocheck
//加时间戳防止cache
const now = new Date().getTime();
const res = await fetch(`${import.meta.env.BASE_URL}env.json?t=${now}`);
const envConfig = await res.json();
//可缓存远程模块的固定版本号，迭代时只需更新此版本号即可刷新缓存
const cacheableRemotesVersion = '1.0.0';
const cacheableRemotes = new Set(['mp_fc', 'mp_low_code', 'mp_cli', 'mp_bdc', 'mp_common']);
//把属性设置挂载到window.mpEnv 对象上
//如果配置文件中指定了环境 则首选它
const env = envConfig.env ?? process.env.VITE_ENV;
const targetProperties = envConfig[env];

for (const key in targetProperties) {
  const val = targetProperties[key];
  if (val && val.indexOf('.js') > 0) {
    if (cacheableRemotes.has(key)) {
      //可缓存模块使用固定版本号，便于浏览器缓存命中，迭代时更换版本号即可
      targetProperties[key] = `${val}?v=${cacheableRemotesVersion}`;
    } else {
      targetProperties[key] = `${val}?t=${now}`;
    }
  }
}

window.mpEnv = targetProperties;
window.env = env;

import('./main');
export default {};
